import { useState } from 'react';
import { Tabs, Tab, Menu, MenuItem, Box } from '@mui/material';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

const FiatCryptoTransactionPanel = ({
    tabs = [],
    menuOptions = [],
    activeCurrencyPage,
    onMenuItemClick,
}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [menuItem, setMenuItem] = useState(null);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleMenuOpen = event => {
        setMenuItem(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuItem(null);
    };

    const clientData = useSelector(state => state.juno.clientData);
    const { readOnly } = clientData || {};

    return (
        <div className="flex !p-3 h-full flex-col items-center gap-3 self-stretch rounded-lg border !border-section-br bg-[#FCFCFC] dark:bg-[#26272B]">
            <div className="flex justify-center w-full h-[40px]">
                <Tabs
                    value={activeTab}
                    onChange={readOnly ? null : handleTabChange}
                    variant="fullWidth"
                    centered
                    scrollButtons
                    allowScrollButtonsMobile
                    className={clsx(
                        'w-full rounded-[8px] !bg-secondary backdrop-blur-[12px] p-0.5',
                        readOnly && 'cursor-not-allowed',
                    )}
                    textColor="inherit"
                    sx={{
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                        '& .MuiTabs-scrollButtons': {
                            color: '#E4E4E7',
                        },
                        overflowX: 'auto',
                        minHeight: '44px',
                    }}>
                    {tabs.map((tab, index) => (
                        <Tab
                            key={tab.key}
                            data-e2e={`${tab.label}-tab-right-corner`}
                            label={tab.label}
                            wrapped
                            disabled={readOnly}
                            sx={{
                                flexGrow: 1,
                                flexShrink: 1,
                                flexBasis: 'auto',
                                textAlign: 'center',
                                minWidth: 0,
                                fontFamily: 'inherit',
                                minWidth: activeTab === index ? 50 : 'auto',
                                borderRadius: '7px',
                                background: activeTab === index ? '#FCFCFC' : 'transparent',
                                color:
                                activeTab === index ? '#18181B' : 'var(--balance-manage-text)',
                                fontWeight: 500,
                                fontSize: '14px',
                                padding: '13px 18px',
                                letterSpacing: '0.14px',
                                lineHeight: '1',
                                minHeight: 'revert',
                              }}
                               className='hover:!bg-[#0000000A] dark:hover:!bg-[#FFFFFF0A]'   
                        />
                    ))}
                </Tabs>
                {activeCurrencyPage === 'fiat' ? (
                    <div
                        className={clsx(
                            'w-[44px] h-[44px] px-2 flex justify-center cursor-pointer items-center ml-2 rounded-[8px] !text-text !bg-secondary',
                            readOnly && '!cursor-not-allowed  disabled:opacity-50',
                        )}
                        onClick={readOnly ? null : handleMenuOpen}>
                        <MoreHorizSharpIcon data-e2e="menu-icon" sx={{ padding: 0 }} />
                    </div>
                ) : null}

                {/* Fiat Menue */}

                {menuOptions.length > 0 && (
                    <Menu
                        anchorEl={menuItem}
                        open={Boolean(menuItem)}
                        onClose={handleMenuClose}
                        MenuListProps={{
                            sx: {
                                padding: 0,
                            },
                        }}
                        slotProps={{
                            paper: {
                                sx: {
                                    backgroundColor: 'var(--common-modal-bg)',
                                    borderRadius: '8px',
                                    minWidth: '160px',
                                },
                            },
                        }}>
                        {menuOptions.map(item => (
                            <MenuItem
                                key={item.key}
                                className="!font-inter"
                                onClick={() => {
                                    handleMenuClose();
                                    onMenuItemClick(item.key);
                                }}
                                sx={{
                                    color: 'var(--color-text)',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    padding: '12px',
                                    textTransform: 'uppercase',
                                    '&:hover': {
                                        backgroundColor: 'var(--card-bg)',
                                    },
                                }}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Menu>
                )}
            </div>

            {/* Tab Content */}
            <Box className="text-white w-full h-full">{tabs[activeTab]?.content}</Box>
        </div>
    );
};

FiatCryptoTransactionPanel.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            content: PropTypes.node.isRequired,
        }),
    ).isRequired,
    menuOptions: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ),
    activeCurrencyPage: PropTypes.string.isRequired,
};

export default FiatCryptoTransactionPanel;
